<template>
<VanPopup
  :show="visible"
  closeable
  position="bottom"
  :style="{ height: '65vh' }"
  @close="handlePopupClose"
>
  <div class="voucher-list">
    <template v-if="voucherList[0]?.length > 0">
      <p class="title">{{  titleText  }}</p>
      <div
        v-for="(voucher, index) in voucherList[0]"
        :key="voucher.genId"
        class="voucher-item"
      >
        <VoucherItemV2
          :item="voucher"
          :show-type="showType"
          :receive-scene="receiveScene"
          @callback="handleUpdateVoucher(voucher, index)"
        />
      </div>
    </template>

    <template v-if="voucherList[1]?.length > 0">
      <p class="title collected-title">Collected</p>
      <div
        v-for="voucher in voucherList[1]"
        :key="voucher.genId"
        class="voucher-item"
      >
        <VoucherItemV2 :item="voucher" :show-type="showType" :receive-scene="receiveScene" />
      </div>
    </template>
  </div>
</VanPopup>
</template>

<script setup lang="ts">
import type { ReceiveScene } from '@/api/models/userInfo'

withDefaults(
  defineProps<{
    visible: boolean,
    titleText?: string
    showType?: 'list' | 'store'
    voucherList: any[],
    receiveScene?: ReceiveScene
  }>(),
  {
    titleText: 'To be collected'
  }
)
const emits = defineEmits<{
  (event: 'update:visible', visible: boolean): void
  (event: 'update:voucher', item: any, index: number): void
}>()
const handlePopupClose = () => {
  emits('update:visible', false)
}

const handleUpdateVoucher = (item: any, index: number) => {
  emits('update:voucher', item, index)
}
</script>

<style lang="scss" scoped>
.voucher-list{
  padding: 60px 30px;
  .title{
    margin: 20px 0;
    font-weight: 600;
    font-size: 28px;
  }
  .collected-title{
    margin-top: 40px;
  }
}
.voucher-list::v-deep(.voucher-v2-item){
  padding: 0;
}
</style>